import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AdminGuard } from '../../guards/admin.guard';
import { VehicleComponent } from './vehicle/vehicle.component';
import { VehiclesComponent } from './vehicles/vehicles.component';

const routes: Routes = [
    {
        path: '',
        component: VehiclesComponent,
    }, {
        path: 'home',
        component: VehiclesComponent,
        canActivate: [AdminGuard]
    }, {
        path: 'veiculo',
        component: VehicleComponent,
        canActivate: [AdminGuard]
    }, {
        path: 'veiculo/:idVehicle',
        component: VehicleComponent,
        canActivate: [AdminGuard]
    }
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})

export class AdminRoutingModule { }
